/**
 * L'app en regard de la formule globale.
 *
 * CE N'EST PAS UN TABLEAU HTML, pour deux raisons : un <table> est illisible
 * sous 400 px, et l'assainisseur du serveur le supprime entièrement — le
 * bloc arriverait vide en base.
 *
 * Une grille de deux colonnes qui s'empile en cartes sur mobile. Chaque
 * ligne porte son libellé, répété dans les deux colonnes sur petit écran :
 * une valeur sans son intitulé ne veut rien dire une fois empilée.
 */
const ComparatifBloc = ({ bloc }) => {
    const lignes = Array.isArray(bloc?.lignes) ? bloc.lignes : [];
    if (lignes.length === 0) return null;

    return (
        <section className="mb-10" data-testid="bloc-comparatif">
            {bloc.titre && (
                <h2 className="text-xl font-bold text-gray-900 mb-5">{bloc.titre}</h2>
            )}

            <div className="grid gap-4 sm:grid-cols-2">
                {[
                    { titre: bloc.colonneA, clef: 'valeurA', mise: true },
                    { titre: bloc.colonneB, clef: 'valeurB', mise: false }
                ].map((colonne, ci) => (
                    <div
                        key={ci}
                        className={`rounded-2xl border p-5 ${
                            colonne.mise
                                ? 'border-purple-200 bg-gradient-to-br from-purple-50 to-pink-50'
                                : 'border-gray-200 bg-white'
                        }`}
                    >
                        {colonne.titre && (
                            <h3 className="font-semibold text-gray-900 mb-3">{colonne.titre}</h3>
                        )}
                        <dl className="space-y-2">
                            {lignes.map((l, i) => (
                                <div key={i} className="flex items-baseline justify-between gap-3 text-sm">
                                    <dt className="text-gray-500">{l.libelle}</dt>
                                    <dd className="font-medium text-gray-900 text-right">{l[colonne.clef]}</dd>
                                </div>
                            ))}
                        </dl>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default ComparatifBloc;
